import { fetchLocationData } from './api';
import { $, greenIcon } from './consts';
import { displayResults } from './ui';
import { L } from './consts';
const tileLayerUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const OsmAttribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
export class GreensMap {
    constructor() {
        this.mapOptions = {
            center: [-41.5, 172.5],
            zoom: 6,
            minZoom: 5,
            maxZoom: 18,
        };
        this.map = L.map('map', this.mapOptions);
        L.tileLayer(tileLayerUrl, { attribution: OsmAttribution, maxZoom: 19 }).addTo(this.map);
        this.setupMapClickHandler();
    }
    setupMapClickHandler() {
        this.map.on('click', async (e) => {
            const { lat, lng } = e.latlng;
            this.setClickMarker(lat, lng);
            const data = await fetchLocationData(lat, lng);
            if (data) {
                $('#address1').val(''); // Clear address input
                displayResults(data);
            }
        });
    }
    setClickMarker(lat, lon) {
        this.clearCurrentMarker();
        this.currentMarker = L.marker([lat, lon], { icon: greenIcon }).addTo(this.map);
    }
    panToLocation(lat, lon, zoom = 15) {
        this.map.setView([lat, lon], zoom, { animate: true });
    }
    clearCurrentMarker() {
        if (this.currentMarker) {
            this.map.removeLayer(this.currentMarker);
            this.currentMarker = undefined;
        }
    }
}
